import axios from 'axios'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import config from '../../../config'

export async function getDisaster(condition = {}) {
  let response = {}
  
  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/DisasterReachSetting`)

  } catch (err) {
    console.error('iisi getDisaster: ', err)
  }

  Utils.setApiResponsSuccess(response)
  return response

}

export async function putDisaster(disaster = {}) {
  let response = {}

  if(Utils.isEmptyObject(disaster) || Utils.isEmptyObject(disaster.id)) {
    console.error('iisi putDisaster: disaster is null')
    Utils.setApiResponsSuccess(response)
    return response
  }

  try {
    response = await axios.put(`${config.eastCoastDataApi()}BaseData/DisasterReachSetting/${disaster.id}`, disaster)

  } catch(err) {
    console.error('iisi putDisaster: ', err)
  }

  Utils.setApiResponsSuccess(response)
  return response
}